<template>
  <component
    :is="resolvedComponent"
    v-if="resolvedComponent && !isAccordionDrilldown"
    v-bind="node.props"
    @row-detail="$emit('row-detail', $event)"
    @input="$emit('input', $event)"
    @filter-change="$emit('filter-change', $event)"
    @update:options="$emit('update:options', $event)"
    @submit="$emit('submit', $event)"
  >
    <DashboardNodeRenderer
      v-for="(child, index) in node.children"
      :key="child.id || index"
      :node="child"
      @row-detail="$emit('row-detail', $event)"
      @input="$emit('input', $event)"
      @filter-change="$emit('filter-change', $event)"
      @update:options="$emit('update:options', $event)"
      @submit="$emit('submit', $event)"
    />
  </component>

  <BaseAccordionDrilldown
    v-else-if="isAccordionDrilldown"
    v-bind="node.props"
  >
    <template v-slot:tab-content="{ tab }">
      <DashboardNodeRenderer
        v-for="(child, index) in (tab.children || [])"
        :key="child.id || index"
        :node="child"
        @row-detail="$emit('row-detail', $event)"
        @input="$emit('input', $event)"
        @filter-change="$emit('filter-change', $event)"
        @update:options="$emit('update:options', $event)"
        @submit="$emit('submit', $event)"
      />
    </template>
  </BaseAccordionDrilldown>

  <div
    v-else
    class="dashboard-node-renderer__unknown"
  >
    Tipo de componente não reconhecido: "{{ node.type }}"
  </div>
</template>

<script>
import dashboardComponentRegistry from './dashboardComponentRegistry'
import BaseAccordionDrilldown from './BaseAccordionDrilldown.vue'

export default {
  name: 'DashboardNodeRenderer',
  components: { BaseAccordionDrilldown },
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  computed: {
    resolvedComponent() {
      return dashboardComponentRegistry[this.node.type] || null
    },
    isAccordionDrilldown() {
      return this.resolvedComponent === BaseAccordionDrilldown
    }
  },
  created() {
    if (process.env.NODE_ENV !== 'production' && !this.resolvedComponent) {
      // eslint-disable-next-line no-console
      console.warn(
        `DashboardNodeRenderer: tipo "${this.node.type}" não existe no dashboardComponentRegistry — renderizando placeholder.`
      )
    }
  }
}
</script>

<style lang="scss">
.dashboard-node-renderer__unknown {
  padding: 10px 14px;
  border: 1px dashed var(--ds-color-black-020);
  border-radius: 6px;
  font-size: 0.8rem;
  color: var(--ds-color-black-055);
}
</style>
